import './../../../css/src/main.scss';

import React from 'react';
import ReactDOM from 'react-dom';

import ReactDraggable from './Draggable.jsx';
import MainMenuStore from './../stores/MainMenuStore';
import SlidesStore from './../stores/SlidesStore';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';
import LandingSlide from './LandingSlide.jsx';
import DescriptionSlide from './DescriptionSlide.jsx';
import GifSlide from './GifSlide.jsx';
import CreditsSlide from './CreditsSlide.jsx';


const Slides = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'Slides',


  /**
   * The iteration of the current content
   */
  contentIteration: 0,


  /**
   * Used to track how many times the user has swiped
   */
  animateIteration: 0,


  /**
   * Starting drag position of the content
   */
  startDragPos: 0,


  /**
   * Ending drag position of the content
   */
  endDragPos: 0,


  /**
   * The amount of pixels the user needs to drag to trigger a transition
   */
  dragThreshold: 10,


  /**
   * The number of slides above and below the current slide
   */
  surroundingSlideAmount: 2,


  /**
   * Timeout to reset the content positions
   */
  resetPositionTimeout: 0,


  /**
   * Expected propTypes
   * @prop {Object} data - A data object
   * @prop {Boolean} large - If the user is viewing the large experience
   * @prop {Number} minDesktopWidth - The minimum width to render the desktop
   * layout
   * @prop {Boolean} touch - If browser supports touch events
   */
  propTypes: {
    data: React.PropTypes.array.isRequired,
    large: React.PropTypes.bool.isRequired,
    touch: React.PropTypes.bool,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      currentSlideData: [],
      dragging: false,
    };
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    MainMenuStore.addChangeListener(this._onMenuChange);
    SlidesStore.addChangeListener(this._onSlidesChange);
    window.addEventListener('resize', this._onResize);

    this.draggableElement = this.refs.draggable;
    this.node = ReactDOM.findDOMNode(this);

    setTimeout(() => {
      this._setCurrentSlideData();
    }, 10);
  },


  /**
   * Called before component is removed from the DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    MainMenuStore.removeChangeListener(this._onMenuChange);
    SlidesStore.removeChangeListener(this._onSlidesChange);
    window.removeEventListener('resize', this._onResize);
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const draggingClass = this.state.dragging ? ' dragging' : '';
    const className = 'component-slides slides-wrapper' + draggingClass;
    const currentSlides = this._renderCurrentSlides();
    let preventDefaultEvents = true;
    if (this.state.menuOpen ||
      (this.contentIteration === this.props.data.length - 1)) {
      preventDefaultEvents = false;
    }

    return (
      <div className={className}>
        <ReactDraggable
          preventDefaultEvents={preventDefaultEvents}
          ref='draggable'
          lock={'y'}
          dragStartCallback={this._dragStartCallback}
          dragStopCallback={this._dragStopCallback}
        >
          <div className='slides'>{currentSlides}</div>
        </ReactDraggable>
      </div>
    );
  },


  /**
   * Called when the user starts dragging the slides
   * @param {Object} draggablePosition - the current x and y position of the
   * draggable element
   * @returns {undefined} undefined
   */
  _dragStartCallback(draggablePosition) {
    clearTimeout(this.resetPositionTimeout);

    this.startDragPos = draggablePosition.y;
    this.setState({ dragging: true });
  },


  /**
   * Called when the user stops dragging the slides
   * @param {Object} draggablePosition - the current x and y position of the
   * draggable element
   * @param {Object} event - A mouse event object
   * @returns {undefined} undefined
   */
  _dragStopCallback(draggablePosition, event) {
    let slideClicked;
    const data = this.props.data;
    this.endDragPos = draggablePosition.y;

    let dif = this.startDragPos - this.endDragPos;
    if (dif < 0) {
      dif = dif * -1;
    }

    if (dif > this.dragThreshold) {
      if (this.endDragPos > this.startDragPos) {
        // dragged down
        if (this.contentIteration - 1 >= 0) {
          this.contentIteration--;
          this.animateIteration--;
        }
      } else {
        // dragged up
        if (this.contentIteration + 1 < data.length) {
          this.contentIteration++;
          this.animateIteration++;
        }
      }
    } else {
      slideClicked = this._checkForSlideClick(event);
      if (slideClicked === 'prev') {
        this.contentIteration--;
        this.animateIteration--;
      }

      if (slideClicked === 'active' &&
        this.contentIteration + 1 < this.props.data.length - 3) {
        this.contentIteration++;
        this.animateIteration++;
      }
    }

    this.setState({ dragging: false }, () => {
      this._setCurrentSlideData();
      this._animateContent();
    });

    this.resetPositionTimeout = setTimeout(() => {
      this._resetSlidePositions();
    }, 600);
  },


  /*
   * Checks to see if a slide was clicked
   * @param {Object} event - A mouseup or touchend event, depending on browser
   * support
   */
  _checkForSlideClick(event) {
    let slideClicked;
    const slideElements = this.node.getElementsByClassName('slide');

    for (let i = 0; i < slideElements.length; i++) {
      const elementBounds = slideElements[i].getBoundingClientRect();
      let clickBounds = {
        x: event.clientX,
        y: event.clientY,
      };

      if (event.changedTouches) {
        clickBounds = {
          x: event.changedTouches[0].clientX,
          y: event.changedTouches[0].clientY,
        };
      }

      if (clickBounds.x > elementBounds.left &&
        clickBounds.x < elementBounds.right &&
        clickBounds.y > elementBounds.top &&
        clickBounds.y < elementBounds.bottom) {
        if (slideElements[i].className.indexOf('next') > -1 ||
          slideElements[i].className.indexOf('active') > -1) {
          slideClicked = 'active';
        }

        if (slideElements[i].className.indexOf('prev') > -1) {
          slideClicked = 'prev';
          break;
        }
      }
    }

    return slideClicked;
  },


  /**
   * Animates the content
   * @returns {undefined} undefined
   */
  _animateContent() {
    let newPos = 0;

    AppDispatcher.handleViewAction({
      actionType: AppConstants.SLIDE_CHANGED,
      slide: this.contentIteration,
    });

    if (!this.props.large) {
      if (this.animateIteration > 0) {
        const slideTop = -(window.innerHeight + ((this.animateIteration - 1) * window.innerWidth));
        newPos = slideTop + ((window.innerHeight - window.innerWidth) / 2);
      }
    } else {
      newPos = -(this.animateIteration * 550);
    }

    this.draggableElement.setPosition({
      x: 0,
      y: newPos,
    });
  },


  /**
   * Jumps to a slide
   * @param {Number} slideIteration - The iteration of the slide to jump to
   * @returns {undefined} undefined
   */
  _jumpToSlide(slideIteration) {
    let dif;
    let changeSlideFunction;

    clearTimeout(this.resetPositionTimeout);

    if (slideIteration < this.contentIteration) {
      dif = this.contentIteration - slideIteration;
      changeSlideFunction = this._reverseSlide;
    } else {
      dif = slideIteration - this.contentIteration;
      changeSlideFunction = this._advanceSlide;
    }

    for (let i = 0; i < dif; i++) {
      setTimeout(() => {
        changeSlideFunction();
      }, i * 10);
    }
  },


  /**
   * Advances the slide
   * @returns {undefined} undefined
   */
  _advanceSlide() {
    this.contentIteration++;
    this.animateIteration++;

    this._setCurrentSlideData();
    this._animateContent();

    this.resetPositionTimeout = setTimeout(() => {
      this._resetSlidePositions();
    }, 600);
  },


  /**
   * Reverses the slide
   * @returns {undefined} undefined
   */
  _reverseSlide() {
    this.contentIteration--;
    this.animateIteration--;

    this._setCurrentSlideData();
    this._animateContent();

    this.resetPositionTimeout = setTimeout(() => {
      this._resetSlidePositions();
    }, 600);
  },


  /**
   * Gets the current slide data
   * @returns {undefined} undefined
   */
  _setCurrentSlideData() {
    const data = this.props.data;
    let slideData = data;
    if (this.props.large) {
      slideData = data.slice(2, data.length);
    }
    const currentSlideData = [];
    let startValue = this.contentIteration - this.surroundingSlideAmount;
    let endValue = this.contentIteration + (this.surroundingSlideAmount + 1);

    if (startValue < 0) {
      startValue = 0;
    }

    if (endValue > slideData.length) {
      endValue = slideData.length;
    }

    for (let i = startValue; i < endValue; i++) {
      currentSlideData.push(slideData[i]);
    }

    this.setState({ currentSlideData });
  },


  /**
   * Renders the current array of slides
   * @returns {Array<ReactElement>} an array of React elements
   */
  _renderCurrentSlides() {
    const data = this.props.data;
    const slideData = this.state.currentSlideData;
    const currentSlides = [];

    for (let i = 0; i < slideData.length; i++) {
      const key = 'slide-' + slideData[i].id;
      const landingHeight = window.innerHeight;
      let prev = false;
      let active = false;
      let next = false;
      let yPosition = 0;
      let height = window.innerWidth;

      if (!this.props.large) {
        if (slideData[i].sortOrder > 1) {
          yPosition = window.innerHeight + ((slideData[i].sortOrder - 2) * window.innerWidth);
        }
      } else {
        height = 400;
        yPosition = 120 + (550 * (slideData[i].sortOrder - 3));
      }


      if (this.animateIteration === 0 && i === 0) {
        active = true;
      } else {
        let activeIteration;
        const lengthDif = data.length - slideData[0].sortOrder;

        if (lengthDif > (this.surroundingSlideAmount + 1)) {
          activeIteration =
            slideData.length - this.surroundingSlideAmount - 1;
        } else {
          activeIteration = this.surroundingSlideAmount;
        }

        if (i === activeIteration - 1) {
          prev = true;
        }

        if (i === activeIteration) {
          active = true;
        }

        if (i === activeIteration + 1) {
          next = true;
        }
      }

      if (slideData[i].type === 'landing' && !this.props.large) {
        currentSlides.push(
          <LandingSlide
            prev={prev}
            active={active}
            next={next}
            descriptionData={this.props.data[1]}
            height={landingHeight}
            large={this.props.large}
            yPosition={yPosition}
            key={key}
          />
        );
      } else if (slideData[i].type === 'description' && !this.props.large) {
        currentSlides.push(
          <DescriptionSlide
            prev={prev}
            active={active}
            next={next}
            data={slideData[i]}
            height={height}
            yPosition={yPosition}
            key={key}
          />
        );
      } else if (slideData[i].type === 'gif') {
        currentSlides.push(
          <GifSlide
            prev={prev}
            active={active}
            next={next}
            data={slideData[i]}
            height={height}
            large={this.props.large}
            yPosition={yPosition}
            key={key}
          />
        );
      } else if (slideData[i].type === 'credits') {
        if (!this.props.large) {
          currentSlides.push(
            <CreditsSlide
              prev={prev}
              active={active}
              next={next}
              data={slideData[i]}
              height={height}
              large={this.props.large}
              yPosition={yPosition}
              key={key}
            />
          );
        }
      }
    }

    return currentSlides;
  },


  /**
   * Resets the slide positions
   * @returns {undefined} undefined
   */
  _resetSlidePositions() {
    /* const _this = this;

    this.animateIteration = 0;

    this.setState({ dragging: true }, () => {
      _this._animateContent();
    });

    this.draggableElement.setPosition({
      x: 0,
      y: 0,
    }); */
  },


  /**
   * Toggles the main menu showing
   * @returns {undefined} undefined
   */
  _toggleMainMenu() {
    if (!this.state.menuOpen) {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.OPEN_MAIN_MENU,
      });
    } else {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.CLOSE_MAIN_MENU,
      });
    }
  },


  /**
   * Called when a CHANGE event is emitted from the MainMenuStore
   * @returns {undefined} undefined
   */
  _onMenuChange() {
    this.setState(MainMenuStore.getState());
  },


  /**
   * Called when a CHANGE event is emitted from the SlidesStore
   * @returns {undefined} undefined
   */
  _onSlidesChange() {
    const _this = this;
    const data = this.props.data;

    this.setState(SlidesStore.getState(), () => {
      if (!_this.state.advanceSlide &&
        !_this.state.reverseSlide &&
        _this.contentIteration !== _this.state.goToSlide) {
        _this._jumpToSlide(_this.state.goToSlide);
      }

      if (_this.state.advanceSlide && _this.contentIteration + 1 < data.length - 3) {
        _this._advanceSlide();
      }

      if (_this.state.reverseSlide && _this.contentIteration - 1 > 0) {
        _this._reverseSlide();
      }
    });
  },
});

export default Slides;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Slides.jsx
 **/